<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
@if (!isLoading) {
  <div>
    <div class="container-fluid self-serve">
      <div class="row">
        <div class="col-sm-10 self-serve-main-container">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
}
